import * as React from 'react'
import { Field, useFormikContext } from 'formik'
import { DebouncedTextField } from '@user/components/Formik'
import Grid from '@mui/material/Grid'
import { TextFieldProps } from '@mui/material/TextField'
import { RuleFieldHelperText } from './RuleFieldHelperText'
import { useCallback, useMemo } from 'react'
import { LeadAssignmentRuleFormModel } from '../typings'

interface Props {
  textFieldProps?: TextFieldProps
  maxRows?: number
  maxCharLength?: number
}

export function RuleDescription(props: Props) {
  const { textFieldProps, maxRows = 1, maxCharLength = 150 } = props

  const {
    setFieldValue,
    values: { description },
  } = useFormikContext<LeadAssignmentRuleFormModel>()

  const descriptionLength = useMemo(
    () =>
      description
        ? description.length < 5
          ? description.trim().length
          : description.length
        : 0,
    [description],
  )

  const helperMessage =
    'Description will be displayed for this rule on the main assignment settings screen.'

  const handleInputChange = useCallback(
    (e) => {
      const lineBreaks = (e.target.value.match(/\n/g) || []).length

      if (lineBreaks > maxRows) {
        setFieldValue('description', e.target.value.replace(/\n/g, ' '))
      }
    },
    [maxRows],
  )

  return (
    <Grid item xs md={12}>
      <Field
        name="description"
        label="Description"
        onChange={handleInputChange}
        component={DebouncedTextField}
        FormHelperTextProps={{ component: 'div' }}
        helperText={
          <RuleFieldHelperText
            message={helperMessage}
            maxLength={maxCharLength}
            counter={descriptionLength}
          />
        }
        InputProps={{
          inputProps: {
            'data-test-id': `leadAssignmentRuleDescriptionInput`,
            maxLength: maxCharLength,
          },
        }}
        {...{
          debounceDelay: 0,
          multiline: true,
          maxRows: 2,
          ...textFieldProps,
        }}
      />
    </Grid>
  )
}
